import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { SettingsNav } from "@/components/SettingsNav";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Shield, Loader2, ShieldCheck } from "lucide-react";

export default function SecuritySettings() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("Le nuove password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password aggiornata");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <PageHeader title="Impostazioni" subtitle="Gestisci la sicurezza del tuo account" icon={Shield} />
      <SettingsNav />
      <div className="grid max-w-3xl gap-6">
        <Card data-testid="change-password-form">
          <CardHeader><CardTitle className="text-base">Cambia password</CardTitle></CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2"><Label>Password attuale</Label><Input type="password" required value={form.current_password} onChange={(e) => set("current_password", e.target.value)} data-testid="current-password" /></div>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="space-y-2"><Label>Nuova password</Label><Input type="password" required minLength={8} value={form.new_password} onChange={(e) => set("new_password", e.target.value)} data-testid="new-password" /></div>
                <div className="space-y-2"><Label>Conferma</Label><Input type="password" required value={form.confirm} onChange={(e) => set("confirm", e.target.value)} data-testid="confirm-password" /></div>
              </div>
              <Button type="submit" disabled={loading} className="rounded-lg" data-testid="change-password-btn">{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Aggiorna password</Button>
            </form>
          </CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle className="text-base">Sicurezza avanzata</CardTitle></CardHeader>
          <CardContent className="space-y-3">
            <div className="flex items-center justify-between rounded-lg border border-border p-4">
              <div className="flex items-center gap-3"><ShieldCheck className="h-5 w-5 text-muted-foreground" /><div><p className="text-sm font-medium">Autenticazione a due fattori (2FA)</p><p className="text-xs text-muted-foreground">Disponibile in una fase successiva</p></div></div>
              <Button variant="outline" size="sm" disabled className="rounded-lg">Prossimamente</Button>
            </div>
            <div className="flex items-center justify-between rounded-lg border border-border p-4">
              <div><p className="text-sm font-medium">Sessioni attive</p><p className="text-xs text-muted-foreground">Le sessioni scadono automaticamente. Il logout revoca l'accesso.</p></div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
